import { EnrollmentBillingItem } from "../../api/getEnrollmentBilling/types";

/**
 * Coverage badge — identity. Always shown. Subtle styling because it's
 * the most common piece of info on the row and shouldn't compete with
 * state badges.
 */
export const coverageBadge: Record<
  EnrollmentBillingItem["coverageType"],
  { label: string; style: string }
> = {
  cash: {
    label: "Cash",
    style: "bg-gray-100 text-gray-600 dark:bg-slate-700 dark:text-gray-300",
  },
  voucher: {
    label: "Voucher",
    style:
      "bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400",
  },
  total_access: {
    label: "Total Access",
    style: "bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400",
  },
};

/**
 * State badge — only shown when there's something to flag (waitlisted /
 * cancelled / fully refunded). Returns null when the enrollment is in
 * its default "active, not refunded" state, so the row only carries the
 * coverage badge.
 *
 * Coverage and state are orthogonal — a refunded cash sale and a
 * refunded voucher seat both render the "Refunded" state badge but
 * keep their respective coverage badges. No information is collapsed.
 */
export function stateBadge(
  item: EnrollmentBillingItem,
): { label: string; style: string } | null {
  if (item.lifecycleState === "waitlisted") {
    return {
      label: "Waitlisted",
      style:
        "bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400",
    };
  }
  if (item.lifecycleState === "cancelled") {
    return {
      label: "Cancelled",
      style: "bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400",
    };
  }
  if (item.isRefunded) {
    return {
      label: "Refunded",
      style: "bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400",
    };
  }
  return null;
}
